import { Component, EventEmitter, Input, OnInit, ChangeDetectorRef, ViewRef, SimpleChanges } from '@angular/core'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import {
    DialogService,
    PageService,
    DossierService,
    FormulaireService
} from '../../../../../services'
import { FormDialogFormulaireWithSFComponent } from '../../form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'

@Component({
    selector: 'atyl-form-dialog-slider',
    templateUrl: './form-dialog-slider.component.html',
    styleUrls: ['./form-dialog-slider.component.scss']
})
export class FormDialogSliderComponent implements OnInit {

    @Input() dossier: any
    @Input() demandeFormulaire: any

    actions: any[] = [];
    currentFormToCreate: any
    currentPageAction: any
    @Input() loading: boolean = true;
    loadingLoader: boolean = true;
    loadingAction: boolean = false;
    classSliderDivided: string = "col-12"

    dateForm: string
    title: any
    atylComponents: string
    atylTemplate: any
    atylDemand: any
    actionForm: string

    listSubscribe: any[] = [];
    listDossierFormulaires: any[] = [];
    loadingFormulaire: boolean = false;
    groups: any[] = [];

    _leftSliderPageCode: string = 'SLIDER';

    formulaireGroups: any[] = [];
    groupes: any[] = [];


    submited: EventEmitter<any> = new EventEmitter<any>();
    constructor(
        private pageService: PageService,
        private dialogService: DialogService,
        private dossierService: DossierService,
        private formulaireService: FormulaireService,
        private changeDetectorRef: ChangeDetectorRef,
    ) {

    }

    ngOnInit(): void {

        this.getGroups();
    }

    getGroups() {
        this.formulaireService.getTypeList().subscribe((res: JSONRpcResponse) => {
            this.formulaireGroups = res.result
            Object.keys(this.formulaireGroups).sort().forEach((id) => {

                let o = {
                    id: id,
                    label: this.formulaireGroups[id]
                };
                this.groupes.push(o);

            });



            console.log("formulaireGroups", this.formulaireGroups, this.groupes);

        })
    }



    ngOnChanges(changes: SimpleChanges) {
        console.log("change open close", changes);

        if (changes['loading'] != undefined &&
            changes['loading'].currentValue) {
            this.loadingLoader = true;
            if (!this.loadingAction)
                this.loadQuickMenu();
            this.loadFormulaireList();
            this.loading = false;
        }
    }

    loadQuickMenu() {
        this.actions = [];
        let columns = 0;
        this.pageService.get(this._leftSliderPageCode).subscribe((res: JSONRpcResponse) => {
            // this.actions = res.result.actions
            let page = res.result;
            let grpButton = [];
           
             let grpButtonWifthOutGroup:any[] = [];
/*
            grpButton[this._leftSliderPageCode] = {
                libelle: page.libelle,
                children: [],
                link: 'etats'
            }*/
            columns++;
            let grpWithoutButton = [];
            page.actions.forEach((action: any) => {
                if (action.sous_groupe) {
                    if (grpButton[action.sous_groupe.key] == undefined) {
                        grpButton[action.sous_groupe.key] = {
                            libelle: action.sous_groupe.libelle,
                            children: [],
                            link: 'etats'
                        };
                        columns++;
                    }
                }
            });
           
            page.actions.forEach((action: any) => {
                let button = action
                let added:boolean=this._checkToAddButton(action.tiers_type);
                if (added)
	                if (button.sous_groupe &&
	                    grpButton[button.sous_groupe.key] != undefined) {
	                    grpButton[button.sous_groupe.key].children.push(button)
	                } else
	                	grpButtonWifthOutGroup.push(button);
	                	
                   // grpButton[this._leftSliderPageCode].children.push(button);
            });
           
			if (grpButtonWifthOutGroup.length>0)
				 grpButton[this._leftSliderPageCode] = {
	                libelle: page.libelle,
	                children: grpButtonWifthOutGroup,
	                link: 'etats'
	            }
	        let grpButtonAdd = [];
	        let groups=Object.keys(grpButton);
	        groups.forEach((key: any) => {
				if (grpButton[key]!=undefined
				 && grpButton[key].children!=undefined
				&&  grpButton[key].children.length>0
				)
				grpButtonAdd[key]=grpButton[key]
			});
			groups=Object.keys(grpButtonAdd);
			if (groups.length>0)
				this.classSliderDivided = "col-" +  Math.round(12 / groups.length) ;
			console.log("slider grpButton",this.dossier,grpButtonAdd,this.classSliderDivided )
            this.actions = grpButtonAdd;
            console.log("slider quickmenu", this.actions);
            this.loadingAction = true;
            this.detectChanges();





        })

    }
    
    _checkToAddButton(tiers_type:any[]) {
        let added:boolean=true;
            
        
        if (this.dossier!=undefined
			&& this.dossier.tiers!=undefined
			&& this.dossier.tiers.type!=undefined
			&& tiers_type.length>0 ) {
            added=false;
            for(let i=0;i<tiers_type.length;i++) {
                if (tiers_type[i].type !=undefined
                  && tiers_type[i].type.code !=undefined
                 && tiers_type[i].type.code===this.dossier.tiers.type)
                   added=true;
            }
           // console.log("checkToAddButton",added,tiers_type,_params.type,button)
        }
        return added;
        
    }

    createForm() {
		console.log("FormDialogSliderComponent createForm");
        const dialogRef=this.dialogService.open(FormDialogFormulaireWithSFComponent, {
            data: {
                create: true,
                idAForm: this.currentPageAction.IdForm,
                dossier: this.dossier ? this.dossier : "",
                v3: true,

            },
            width: "90vw",
            height: '90vh',
            resizable: true,
            minimizable: true,
            maximizable: true,
            draggable: true,
        })
		
		if (dialogRef) {
					 dialogRef.afterClosed().subscribe((response: JSONRpcResponse) => {
			      		if(response && response.result){
							console.log("FormDialogSliderComponent createdForm",response.result);
							this.loadFormulaireList();  
						}
						
						
					});
			}
		
    }
    triggerClicked(event: any) {
        this.currentPageAction = event;
        this.loadFormulaireList();
    }

    loadFormulaireList() {
        console.log("slider loadFormulaireList");
        this.listDossierFormulaires = []
        this.loadingFormulaire = true
        this.groups = []
        let _opts={
			getAll:	true
		}
		
		this.listSubscribe.push(
            this.dossierService
                .getformulairelist(this.dossier.ID,_opts)
                .subscribe((res: JSONRpcResponse) => {
                    this.listDossierFormulaires = []

                    res.result.forEach((form: any) => {
                        if (form.form) {
                            console.log("slider loadFormulaireList loaed", form.form);
                            let formData = {
                                typeFormulaire: form.form.key,
                                dossierId: this.dossier.ID,
                                title: form.form.libelle,
                                form: form.form,
                                demande: form.demande,
                                demandeFormulaire: form,
                                isEditable: true,
                            }
                            if (this.listDossierFormulaires.indexOf(formData) === -1) {
                                this.listDossierFormulaires.push(formData)
                            }

                        }
                    })

                    this.groupfiy(this.listDossierFormulaires)
                    this.loadingFormulaire = false
                    this.loadingLoader = false;
                    this.detectChanges()
                }, (err) => {
                    console.error(err)
                }, () => {
                    this.loadingFormulaire = false
                    this.loadingLoader = false;
                    this.detectChanges()
                })
        )
    }

    groupfiy(listDossierFormulaires: any[]) {

        this.groups = []

        listDossierFormulaires.forEach((formData: any) => {

            if (this.groups[formData.form.key] !== undefined) {
                if ((this.groups[formData.form.key]["formulaires"] as Array<any>).indexOf(formData) === -1) {
                    this.groups[formData.form.key]["formulaires"].push(formData)
                }
            } else {
                this.groups[formData.form.key] = {
                    ID: formData.form.ID,
                    title: formData.form.libelle,
                    type: formData.form.type,
                    formulaires: [formData],
                    color: "",
                    icon: "",
                }

                this.pageService.getPageAction(formData.form.ID).subscribe((res: JSONRpcResponse) => {
                    console.log(res.result)

                    if (res.result["couleur"]) this.groups[formData.form.key].color = res.result["couleur"];
                    if (res.result["icone"]) this.groups[formData.form.key].icon = "la " + res.result["icone"];

                    this.detectChanges()
                });
            }
        })

        this.loadingFormulaire = false
        this.detectChanges()
    }

    keys() {
        let kkey = Object.keys(this.groups);
        kkey.sort();
        return kkey;
    }

    keysAction() {
        let kkey = Object.keys(this.actions);
        kkey.sort();
        return kkey;
    }


    detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }

    formulaireSelect(formulaire: any) {
        /*this.loadingFormulaire = true
        this.currentFormulaire = undefined
        this.currentFormulaire = formulaire
        this.loadingFormulaire = false*/
        console.log("fefore open", formulaire)
        if (formulaire.demandeFormulaire.ID != this.demandeFormulaire.ID)
            this.popupFormulaire(formulaire)
    }

    popupFormulaire(formulaire: any) {
        console.log("fefore open2", formulaire)
        let form = formulaire.form
        let demandeForm = formulaire.demandeFormulaire
		let dialogRef:any;
		if (form && form.under_form && form.under_form.length === 0) {
            let datasF = {
                title: form.libelle,
                id: demandeForm.ID,
                formType: demandeForm.key,
                idDemandeForm: form.ID,
            }
            datasF['dossier'] = this.dossier

            dialogRef=this.dialogService.open(FormDialogFormulaireWithSFComponent, {
                //data: formulaire,
                data: datasF,
                height: '90vh',
                width: "90vw",
                resizable: true,
                minimizable: true,
                draggable: true,
                maximizable: true,
            })
        }
        else if (form && form.under_form && form.under_form.length > 0) {
            let form = formulaire.form
            let demandeForm = formulaire.demandeFormulaire
            /*if (form && form.under_form && form.under_form.length === 0) {
                this.dialogService.open(FormDialogFormulaireComponent, {
                    data: formulaire,
                    height: '90vh',
                    width: '80vw',
                    resizable: true,
                    minimizable: true,
                    maximizable: true,
                    draggable: true,
                }, (result: any) => {
                    this.loadingFormulaire = false
                })
            } else if (form && form.under_form && form.under_form.length > 0) {
             */
            let datasF = {
                title: form.libelle,
                id: demandeForm.ID,
                formType: demandeForm.key,
                idDemandeForm: form.ID,
            }
            datasF['dossier'] = this.dossier
            dialogRef=this.dialogService.open(FormDialogFormulaireWithSFComponent, {
                data: datasF,
                height: '90vh',
                width: "90vw",
                resizable: true,
                minimizable: true,
                draggable: true,
                maximizable: true,
            })


            //}
        }
		
		if (dialogRef) {
		//	console.log("FormDialogSliderComponent popupFormulaire",dialogRef);
			 dialogRef.afterClosed().subscribe((response: any) => {
					      		
									console.log("FormDialogSliderComponent popupedFormulaire",response);
									this.loadFormulaireList();  
								
								
								
							});
		}
		
    }

}
